const successPhoto = 'https://ti2020-qa-storage.tolunastart.com/tcp/images/thankyoucheck-02.png';
const logoUrl = 'https://ti2020-qa-storage.tolunastart.com/tcp/images/logo.png';

export const defaultTheme = {
    mainFontFamily: 'Raleway',
    mainColor: '#e2e039',
    header: {
        logoImage: {
            width: '178px',
            height: '30px',
            paddingIsOnTop: '24px 0',
            padding: '8px 0 8px',
            imageUrl: logoUrl
        },
        myProjects: {
            borderBottomColor: '#E40049',
            fontFamily: 'MuseoSans-500'
        },
        createButton: {
            fontFamily: 'MuseoSans-700',
            iconColor: '#0196d6',
            color: '#0196d6',
            colorHover: '#006590',
            backgroundColor: 'transparent',
            backgroundColorHover: '#efefef',
            textTransform: '',
            header: {
                chooseFrom: {
                    fontFamily: 'Raleway'
                },
                createCustomButton: {
                    fontFamily: 'Raleway',
                    color: '#0196D6',
                    borderColor: '#0196D6',
                    backgroundColor: 'transparent',
                    colorHover: '#0196D6',
                    backgroundColorHover: 'transparent'
                }
            },
            content: {
                categories: {
                    fontFamily: 'Raleway',
                    color: '#60738F',
                    colorHover: '#0196D6',
                    colorSelected: '#0196D6'
                },
                items: {
                    backgroundColor: '',
                    backgroundBorderRadius: '',
                    item: {
                        fontFamily: 'Raleway',
                        color: '#60738F',
                        borderHover: '',
                        border: '',
                        padding: ''
                    }
                },
                demoSection: {
                    sidebar: {
                        title: {
                            fontFamily: 'Raleway',
                            color: 'rgba(43, 150, 214, 1)'
                        },
                        description: {
                            fontFamily: 'Raleway',
                            color: 'rgba(110, 127, 155, 1)'
                        }
                    },
                    demoForm: {
                        title: {
                            fontFamily: 'Raleway',
                            color: 'rgba(43, 150, 214, 1)'
                        },
                        button: {
                            fontFamily: 'Raleway',
                            borderColor: 'rgba(43, 150, 214, 1)'
                        },
                        label: {
                            color: 'rgba(83, 83, 83, 1)',
                            fontFamily: 'Raleway'
                        },
                        inputField: {
                            fontFamily: 'Raleway',
                            border: '#ACACAC',
                            onFocusBorder: '1px solid #2B96D6'
                        },
                        success: {
                            color: 'rgba(43, 150, 214, 1)',
                            fontFamily: 'Raleway'
                        }
                    }
                }
            }
        },
        userMenu: {
            fontFamily: 'MuseoSans-500',
            iconColor: 'rgba(1, 150, 214, 1)'
        }
    },
    footer: {
        contactUs: {
            title: {
                fontFamily: 'GreycliffCF',
                color: '#102833',
                borderTopColor: '#0196D6'
            },
            button: {
                fontFamily: 'GreycliffCF',
                backgroundColor: '#0196D6',
                backgroundColorHover: '#017fb5'
            },
            success: {
                image: successPhoto,
                thankYou: {
                    fontFamily: 'GreycliffCF',
                    color: '#102833'
                },
                response: {
                    fontFamily: 'GreycliffCF',
                    color: '#60738F'
                }
            }
        },
        rights: {
            fontFamily: 'GreycliffCF'
        },
        link: {
            fontFamily: 'GreycliffCF'
        }
    }
};
